import React from "react";
import { IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  ticketHeader: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    minHeight: 56,
    maxHeight: 56,
    paddingRight: theme.spacing(0.5),
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    overflow: "hidden",
  },
  backButton: {
    flexShrink: 0,
    marginLeft: theme.spacing(0.5),
    color: theme.palette.primary.main,
  },
  headerBody: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    gap: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

const TicketHeader = ({ loading, children }) => {
  const classes = useStyles();
  const history = useHistory();

  if (loading) {
    return <TicketHeaderSkeleton />;
  }

  return (
    <header className={classes.ticketHeader}>
      <IconButton
        className={classes.backButton}
        onClick={() => history.push("/tickets")}
        edge="start"
        size="small"
        aria-label="back"
      >
        <ArrowBackIos fontSize="small" />
      </IconButton>
      <div className={classes.headerBody}>{children}</div>
    </header>
  );
};

export default TicketHeader;
